import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Zap, Sun, Shield, Lock, Car } from 'lucide-react';

const iconMap = { Zap, Sun, Shield, Lock, Car };

/**
 * Services (CI-clean)
 * - Keine "Verkaufsfarben" / keine Blue-Highlights pro Karte
 * - Gleichwertige Darstellung (Systembausteine)
 * - Ruhiges Raster, klare Hierarchie
 */
export default function ServicesSection({ services, scrollToSection, dataBg = 'light' }) {
  return (
    <section
      id="services"
      data-bg={dataBg}
      className="py-20 bg-eos-weißFast text-eos-grauDunkel"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="max-w-3xl">
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight">
            Leistungen
          </h2>
          <p className="mt-4 text-eos-grauDunkleres">
            Systembausteine, die in der Planung zusammengeführt werden. Keine isolierten Einzelmaßnahmen.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const Icon = iconMap[service.icon] || Zap;
            return (
              <div
                key={service.id}
                className="group rounded-none border border-eos-sek-blauGrau bg-eos-weißFaster p-6 transition-colors hover:border-eos-grauNeutral"
              >
                <div className="flex items-start gap-4">
                  <div className="shrink-0">
                    <div className="h-12 w-12 rounded-none border border-eos-sek-blauGrau bg-eos-weißFast flex items-center justify-center">
                      <Icon className="h-6 w-6 text-eos-prim-blue" />
                    </div>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-lg font-semibold">{service.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-eos-grauDunkleres">
                      {service.description}
                    </p>
                    {Array.isArray(service.features) && service.features.length > 0 && (
                      <ul className="mt-4 space-y-2 text-sm text-eos-grauDunkleres">
                        {service.features.slice(0, 3).map((f, idx) => (
                          <li key={idx} className="flex gap-2">
                            <span className="mt-[7px] h-1.5 w-1.5 bg-eos-prim-blue" />
                            <span className="truncate">{f}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 flex">
          <Button
            size="lg"
            className="rounded-none bg-eos-prim-blue text-eos-weißFast hover:bg-eos-prim-blauStark"
            onClick={() => scrollToSection?.('contact')}
          >
            Projekt besprechen
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
}
